import { render, staticRenderFns } from "./CongressmanProcessing.vue?vue&type=template&id=6ba97f88&scoped=true"
import script from "./CongressmanProcessing.vue?vue&type=script&lang=js"
export * from "./CongressmanProcessing.vue?vue&type=script&lang=js"
import style0 from "./CongressmanProcessing.vue?vue&type=style&index=0&id=6ba97f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba97f88",
  null
  
)

export default component.exports